/**
 * Leichtgewichtiges Product Event Tracking
 * - Views: via IntersectionObserver, gebatcht (alle 3s)
 * - Clicks: sofort beim Klick
 * - Affiliate-Clicks: via sendBeacon (page-leave sicher)
 */
const viewQueue = new Set<string>()
let flushTimer: ReturnType<typeof setTimeout> | null = null

function getTrackUrl(): string {
  const config = useRuntimeConfig()
  return `${config.public.apiBase}/api/products/track`
}

function flushViews() {
  if (viewQueue.size === 0) return
  const ids = [...viewQueue]
  viewQueue.clear()

  const url = getTrackUrl()
  ids.forEach(productId => {
    $fetch(url, {
      method: 'POST',
      body: { productId, eventType: 'view' },
    }).catch(() => {})
  })
}

function scheduleFlush() {
  if (flushTimer) return
  flushTimer = setTimeout(() => {
    flushTimer = null
    flushViews()
  }, 3000)
}

export function trackProductView(productId: string) {
  if (typeof window === 'undefined') return
  viewQueue.add(productId)
  scheduleFlush()
}

export function trackProductClick(productId: string) {
  if (typeof window === 'undefined') return
  const url = getTrackUrl()
  $fetch(url, {
    method: 'POST',
    body: { productId, eventType: 'click' },
  }).catch(() => {})
}

export function trackAffiliateClick(productId: string) {
  if (typeof window === 'undefined') return
  const url = getTrackUrl()
  if (navigator.sendBeacon) {
    navigator.sendBeacon(
      url,
      JSON.stringify({ productId, eventType: 'affiliate_click' })
    )
  } else {
    $fetch(url, {
      method: 'POST',
      body: { productId, eventType: 'affiliate_click' },
    }).catch(() => {})
  }
}
